import { useState } from "react";
import { useNavigate } from "react-router-dom";
import userClient from '../../infrastructure/userClient';
import User from '../../domain/User';
import LoadingPopup from '../loading/LoadingPopup';
import { useMutation } from "@tanstack/react-query";
import {useLoggedUserContext} from "../../AppContext";
import ErrorPopup from "../error/ErrorPopup";
import UIError from "../UIError";
import "./LoginForm.css";

export default function LoginForm() {
    const navigate = useNavigate();
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');

    const setLoggedUser = useLoggedUserContext()[1];
    const loginUserQuery = useMutation({mutationFn: async () => await loginUser(login, password)});
    
    if (loginUserQuery.isSuccess) {
        const user = loginUserQuery.data;

        if (user) {
            setTimeout(() => {
                setLoggedUser(user);
                navigate('/');
            });
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        loginUserQuery.mutate();
    }

    return <>
        {loginUserQuery.isError && renderError(loginUserQuery.error)}
        {(loginUserQuery.isPending || loginUserQuery.isSuccess) ? <LoadingPopup/> : null} 
        <form onSubmit={e => handleSubmit(e)}>
            <div>
                <label>Login: </label>
                <input type="text" required value={login} onChange={e => setLogin(e.target.value)}/>
            </div>
            <div>
                <label>Password: </label>
                <input type="password" required value={password} onChange={e => setPassword(e.target.value)}/>
            </div>
            <div>
                <button>Login</button>
            </div>
        </form>
    </>
}

function renderError(error) {
    if (error.name === "UIError" && error.message === "LOGIN_FAILED") {
        return <div className="errorField">Wrong user or password</div>
    }

    return <ErrorPopup message={error.message}/>
}

async function loginUser(login, password) {
    const res = await userClient.login(login, password);

    if (res.ok) {
        const json = await res.json();
        return new User(json);
    }

    if (res.status === 401) {
        throw new UIError("LOGIN_FAILED");
    }

    throw new UIError("Error status code: " + res.status);
};